import { Directive, ElementRef } from '@angular/core';
import { LineRowComponent } from '../tables/line-row/line-row.component';

@Directive({
    selector: '[textLineElement]',
    standalone: false
})
export class TextLineElementDirective {
  constructor(public elementRef: ElementRef, public lineRowComponent: LineRowComponent) { }
}
